import React, { FC, ReactElement } from 'react';

import { AssignToPersonType, Expression, WorkflowContext } from '@typings/api-models';
import ConditionsWidget from '../DesignLibrary/ConditionsWidget';
import AssigneeSelectorWorkflowInvoices from './AssigneeSelectorWorkflowInvoices';
import { TBody, TD, TH, THead, Table, TableRow } from '../DesignLibrary/Table';
import Button from '../DesignLibrary/Button';

type Props = {
  refetchWorkflow: () => Promise<void>;
  workflowId?: string;
  invoices: {
    id: string;
    referenceId: string;
    title: string;
    expression?: Expression | null;
    workflowInvoiceAssigneeIds?: string[] | null;
  }[];
  availableAssignees: { key: string; label: string; type: AssignToPersonType }[];
  removeInvoice: (attachmentId: string) => void;
  handleUpdateConditions: (
    workflowInvoiceId: string,
    metaData: {
      workflowInvoiceAssigneeIds?: string[];
      expressionId?: string;
    },
  ) => void;
  workflowContexts: Pick<WorkflowContext, 'slug' | 'id' | 'label'>[];
};

const WorkflowInvoices: FC<Props> = ({ availableAssignees, invoices, workflowContexts, removeInvoice, handleUpdateConditions }): ReactElement => {
  const AssignedToHandle = (assigneeIds: string[] = []): string => {
    const assigneesLabels: string[] = [];
    availableAssignees?.forEach(person => {
      if (assigneeIds.includes(person?.key)) {
        assigneesLabels.push(person.label);
      }
    });
    if (assigneesLabels?.length) {
      return assigneesLabels?.join(', ');
    }
    return '';
  };
  return (
    <Table>
      <THead>
        <TableRow>
          <TH label="Title" />
          <TH label="Assigned to" />
          <TH label="Conditions" />
          <TH label="" />
        </TableRow>
      </THead>
      <TBody>
        {invoices.length > 0 && invoices.map(
          (invoice: {
            id: string;
            referenceId: string;
            title: string;
            expression?: Expression | null;
            workflowInvoiceAssigneeIds?: string[] | null;
          }) => (
            <TableRow key={invoice.referenceId}>
              <TD compact label={invoice.title} />
              <TD>
                {invoice?.workflowInvoiceAssigneeIds
                  && invoice.workflowInvoiceAssigneeIds.length > 0
                  && <span className="caption">{AssignedToHandle(invoice?.workflowInvoiceAssigneeIds ?? [])}</span>}
                <AssigneeSelectorWorkflowInvoices
                  handleSubmit={(workflowInvoiceAssigneeIds: string[]) => handleUpdateConditions(invoice.id, { workflowInvoiceAssigneeIds })}
                  invoiceData={invoice}
                  availableAssignees={availableAssignees}
                />
              </TD>
              <TD>
                <ConditionsWidget
                  conditionalExpression={invoice.expression || null}
                  options={workflowContexts.map(context => ({
                    key: context.slug || context.id,
                    label: context.label,
                  }))}
                  type={'workflow-context'}
                  onOpenModal={() => {}}
                  handleSubmit={expressionId => {
                    handleUpdateConditions(invoice.id, { expressionId });
                  }}
                />
              </TD>
              <TD>
                <Button variant='destructive' size='xs' onClick={() => removeInvoice(invoice.id)}>Remove invoice</Button>
              </TD>
            </TableRow>
          ),
        )}
      </TBody>
    </Table>
  );
};

export default WorkflowInvoices;
